<template>
    <div>
        <div class="row mb-3">
            <div class="col col-12 col-md-4">
                <az-input
                    label="Unidade"
                    type="select"
                    :optionsList="lista_unidades"
                    optionsData="id_unidade_operacao"
                    placeholder="Selecione a unidade..."
                    :edicao="!dados"
                    v-model="filtros.unidade" />
            </div>
            <div class="col col-12 col-md-4">
                <az-input
                    placeholder="Operadora/Plano..."
                    label="Operadora/Plano"
                    type="autocomplete"
                    optionsMode="aql"
                    optionsName="planos.atendimento"
                    :optionsParm="{
                        atendimento: true,
                        plano_id_unidade_operacao: filtros.unidade
                    }"
                    service="planos.index"
                    :optionsSync="false"
                    optionsData="id_plano"
                    v-model="filtros.operadora"
                    :edicao="!dados"
                    ref="info_plano" />
            </div>
            <div class="col col-12 col-md-2">
                <az-input
                    label="Série da OS"
                    type="number"
                    :edicao="!dados"
                    v-model="filtros.serie" />
            </div>
            <div class="col col-12 col-md-2">
                <az-input
                    label="Número da OS"
                    type="number"
                    :edicao="!dados"
                    v-model="filtros.numero" />
            </div>
        </div>

        <az-empty-state 
            icon="fa fa-search"
            msg="Buscar Atendimento"
            action="Buscar"
            :method="load"
            v-if="dados === null" />

        <template v-else>
            <div v-if="dados.logs && dados.logs.length">
                <div v-for="(log, ilx) in dados.logs" :key="ilx" class="alert" :class="'alert-' + log.level">
                    {{ log.msg }}
                </div>
            </div>

            <div class="alert alert-primary d-flex justify-content-between" v-if="dados && dados.marcacao">
                <div>
                    <div>
                        <span class="text-muted mr-1">Atendimeto:</span>
                        <a href="#" @click.prevent="abrir_atendimento(dados.marcacao.id_atendimento)" class="card-link">
                            #{{ dados.marcacao.id_atendimento }}
                        </a>
                    </div>

                    <div>
                        <span class="text-muted mr-1">OS:</span>
                        <span>{{ dados.marcacao.st_id_externo }}</span>
                    </div>

                    <div>
                        <span class="text-muted mr-1">Matrícula:</span>
                        <span>{{ dados.marcacao.atendimento.st_numero_carteira }}</span>
                    </div>

                    <div>
                        <span class="text-muted mr-1">Credenciais:</span>
                        <span>
                            {{ 
                                ( dados.marcacao.paciente.login_reembolso && dados.marcacao.paciente.login_reembolso.st_login ) 
                                    ? 'Preenchidas' 
                                    : 'Não Preenchidas'
                            }}
                        </span>
                        <span v-if="dados.marcacao.paciente.login_reembolso && dados.marcacao.paciente.login_reembolso.st_login"
                            class="badge badge-primary ml-2">
                            Login: {{ dados.marcacao.paciente.login_reembolso.st_login }}
                        </span>
                        <span v-else class="text-danger ml-2">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        </span>
                    </div>

                    <div>
                        <span class="text-muted mr-1">Valor Total:</span>
                        <span>{{ $util.formatMoeda(valor_total) }}</span>
                    </div>
                </div>

                <div>
                    <button type="button" class="btn btn-primary" @click="reset()">Reiniciar</button>
                </div>
            </div>

            <div class="mb-3 mx-3" v-if="dados && dados.marcacao">

                <div class="row my-2 py-1 dashcard align-items-center bg-white" class2="w3-animate-opacity">
                <!-- Ação -->
                <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                    <div class="d-flex flex-column">
                        <button class="btn btn-outline-primary btn-sm" @click="novoDocumento(dados.marcacao)">
                            Emitir Documento
                        </button>
                    </div>
                </div>

                <!-- Hora da Marcação -->
                <div class="col col-12 col-md-2 d-flex justify-content-center justify-content-md-start">
                    <celula-horarios-marcacao :hor="dados" />
                </div>

                <!-- Identificação do Paciente -->
                <div class="col col-12 col-md-4">
                    <celula-dados-paciente :hor="dados" v-if="dados.marcacao" />
                </div>

                <!-- Identificação do Procedimento -->
                <div class="col col-12 col-md-4 d-flex justify-content-between" v-if="dados.marcacao">
                    <celula-dados-procedimento 
                        :hor="dados" 
                        @abriranexos="abrir_anexar_arquivo" 
                        :total="dados.marcacao.atendimento 
                            ? dados.marcacao.atendimento.atendimento_procedimentos.length
                            : 0" />

                    <!--
                        @abrirpreatend="$refs.doc_pre_atend.abrir" />
                    -->

                    <!-- Menu de opções -->
                    <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2" v-if="dados.marcacao.ch_estado_marcacao != 'C'">
                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-ellipsis-v"></i>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <button v-if="dados.marcacao && dados.marcacao.atendimento" class="dropdown-item" @click="$refs.amostras.abrir(dados.marcacao.id_atendimento)">
                            Exames
                        </button>
                        <button class="dropdown-item" 
                            v-if="false && dados.marcacao && dados.marcacao.atendimento && dados.marcacao.st_id_externo" 
                            @click="$refs.integra.abrir(dados.marcacao)">
                            Verificar Integração
                        </button>
                        <button class="dropdown-item" @click="abrir_anexar_arquivo(dados.marcacao)" :disabled="!dados.marcacao">
                            Anexar Arquivo
                            <span class="badge badge-secondary" v-if="dados.marcacao.arquivos && dados.marcacao.arquivos.length">
                                {{ dados.marcacao.arquivos.length }}
                            </span>
                        </button>
                        <template v-if="dados.marcacao">
                            <button class="dropdown-item" @click="novoDocumento(dados.marcacao)">Emitir Documento</button>
                        </template>
                    </div>
                    </div>

                </div>
                </div>

            </div>

            <table class="table bg-white" v-if="dados && dados.marcacao && dados.marcacao.atendimento">
                <thead>
                    <th>Procedimento</th>
                    <th class="text-right">Valor</th>
                </thead>
                <tbody>
                    <tr v-for="(proc, ipx) in dados.marcacao.atendimento.atendimento_procedimentos" :key="ipx">
                        <td>
                            {{ proc.procedimento.search }}
                            <div class="small text-muted" v-if="proc.amostra">
                                {{ proc.amostra.search }}
                            </div>
                        </td> 
                        <td class="text-right">
                            {{ $util.formatMoeda(proc.cd_valor_total) }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <button type="button" class="btn btn-primary mt-3" @click="reset()" v-if="!dados.marcacao">Reiniciar</button>

            <pre class="alert alert-warning" v-if="false && dados">{{ dados }}</pre>
        </template>

        <!-- Documentos -->
        <documento ref="documento" :recepcao="true" refresh="imprimir_documento" />

        <!-- Amostras -->
        <amostras ref="amostras" :viewonly="true" />
        <validar-integracao ref="integra" />   

        <!-- Anexar Arquivo -->
        <template v-if="acao_anexar && dados && dados.marcacao">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="dados.marcacao.arquivos"
                :parms="{ 
                    model_type: 'marcacao', 
                    model_id: dados.marcacao.id_marcacao, 
                    id_paciente: dados.marcacao.id_paciente 
                }" />
        </template>
    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaHorariosMarcacao from "../../shared/table/CelulaHorariosMarcacao.vue";
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import Documento from '../consultorio/Documento.vue';
import Amostras from '../laboratorio/Amostras.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import ValidarIntegracao from '../reembolso/ValidarIntegracao.vue';

export default {
    data() { 
        return { 
            filtros: { 
                unidade: "",
                operadora: "",
                serie: "", 
                numero: "", 
            },
            validate: false, 
            dados: null, 
            acao_anexar: false,
        }
    },

    components: { 
        AzInput,
        AzEmptyState,
        CelulaHorariosMarcacao,
        CelulaDadosPaciente,
        CelulaDadosProcedimento, 
        Documento, 
        Amostras,
        AzFileUpload,  
        ValidarIntegracao
    }, 

    computed: { 
        lista_unidades: function () {
            return _.orderBy(
                this.$util.unidades_com_tags(false, true).filter(item => !item.fl_unidade_adm),
                'st_nome'
            );
        },

        valor_total: function () { 
            if ( !this.dados || !this.dados.marcacao || !this.dados.marcacao.atendimento ) { 
                return 0;
            }

            return this.dados.marcacao.atendimento.atendimento_procedimentos.reduce((total, carry) => { 
                return total + parseFloat(carry.cd_valor_total);
            }, 0);
        }
    },

    methods: { 
        abrir_anexar_arquivo() {
            this.acao_anexar = true;

            if ( this.dados.marcacao.arquivos && this.dados.marcacao.arquivos.length && !this.dados.marcacao.arquivos.find(arq => arq.arquivo) ) {
                this.carregar_arquivos(true);
                return;
            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                id: this.dados.marcacao.id_marcacao,
                type: 'marcacao',
                }
            })
            .then(res => {
                this.dados.marcacao.arquivos = res;

                if ( abrir ) {
                this.$nextTick(() => {
                    this.$refs.upload.abrir();
                });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });

        },

        abrir_atendimento(id) { 
            this.$util.abrir_atendimento(this, id);
        },

        reset() { 
            this.dados = null;
            this.filtros.numero = "";
        },

        load() {
            this.$util.setCookie('reemb-int-plano', this.filtros.operadora, 365);

            this.$util.load(this, { 
                service: 'terceiros',
                func: 'obter_os_labchecap',
                redir_api: true, 
                parms: this.filtros, 
                loadTo: res => { 
                    this.dados = res; 
                }
            });
        },

        novoDocumento(marcacao) {
            if ( marcacao ) { 
                this.$refs.documento.novoDocumento(marcacao);
            }
        },
    },

    beforeMount() { 
        this.filtros.unidade = this.$util.getCookie('id_unidade_operacao');
        this.filtros.operadora = this.$util.getCookie('reemb-int-plano');
    },

    mounted() { 
        this.$store.commit('setBreadcrumb', 
            [
                { name: "Recepção", path: "/recepcao"},
                { name: "Integrar Atendimento", path: ""},
            ]);

        let numero_externo = this.$route.params.numero;

        if ( numero_externo ) {
            let serie = _.get(numero_externo.split('.'), '0');
            let num = _.get(numero_externo.split('.'), '1');

            if ( !isNaN(serie) && !isNaN(num) ) { 
                this.filtros.serie = serie;
                this.filtros.numero = num;
            }
        }
    }
}
</script>